import type {
  QuestionOptionTranslationData,
  QuestionTranslationData,
} from 'src/types/formQuestionnaire';

type ApiQuestionTranslationRow = {
  languageCode?: string | null;
  questionText?: string | null;
  description?: string | null;
};

type ApiOptionTranslationRow = {
  languageCode?: string | null;
  optionText?: string | null;
};

export function mapApiQuestionTranslations(
  rows?: ApiQuestionTranslationRow[] | null,
): QuestionTranslationData[] | undefined {
  if (!rows?.length) return undefined;
  const mapped = rows
    .filter((t) => t.languageCode?.trim() && t.questionText?.trim())
    .map((t) => {
      const desc = t.description?.trim();
      return {
        languageCode: t.languageCode!.trim(),
        questionText: t.questionText!.trim(),
        description: desc && desc.length > 0 ? desc : null,
      };
    });
  return mapped.length ? mapped : undefined;
}

export function mapApiOptionTranslations(
  rows?: ApiOptionTranslationRow[] | null,
): QuestionOptionTranslationData[] | undefined {
  if (!rows?.length) return undefined;
  const mapped = rows
    .filter((t) => t.languageCode?.trim() && t.optionText?.trim())
    .map((t) => ({
      languageCode: t.languageCode!.trim(),
      optionText: t.optionText!.trim(),
    }));
  return mapped.length ? mapped : undefined;
}
